import swal from 'sweetalert2';

const timer = 5000;
export function success(title, text) {
  swal({
    type: 'success',
    title,
    text,
    timer,
  }).catch(swal.noop);
}
export function error(title, text) {
  swal({
    type: 'error',
    title,
    text,
    timer,
  }).catch(swal.noop);
}
export function info(title, text) {
  swal({
    type: 'info',
    title,
    text,
    timer,
  }).catch(swal.noop);
}
export function warning(title, text) {
  swal({
    type: 'warning',
    title,
    text,
    timer,
  }).catch(swal.noop);
}
export function loading() {
  swal.showLoading();
}
export function close() {
  swal.close();
}



// WEBPACK FOOTER //
// ./src/helpers/Alert.js